import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
(
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// ----------------------------------------------------------------------

// Auth
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));

// Studio
export const CreatorPage = Loadable(lazy(() => import('../pages/studio/CreatorPage')));
// export const DraftsPage = Loadable(lazy(() => import('../pages/studio/DraftsPage')));

// Dashboard
export const AnalyticsPage = Loadable(lazy(() => import('../pages/dashboard/AnalyticsPage')));
export const ProductsPage = Loadable(lazy(() => import('../pages/dashboard/ProductsPage')));



// Extra
export const PageOne = Loadable(lazy(() => import('../pages/PageOne')));
export const PageThree = Loadable(lazy(() => import('../pages/PageThree')));
export const PageFour = Loadable(lazy(() => import('../pages/PageFour')));
export const PageFive = Loadable(lazy(() => import('../pages/PageFive')));
export const PageSix = Loadable(lazy(() => import('../pages/PageSix')));

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
